import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { sendEmailViaBackend } from '../services/emailService';
import './Pricing.css';

const Pricing = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    contactNo: '',
    websiteURL: '',
    companyName: '',
    description: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    setStatusMessage('');

    try {
      const result = await sendEmailViaBackend({
        ...formData,
        interest: 'Pricing Quote Request'
      });

      if (result.success) {
        setSubmitStatus('success');
        setStatusMessage(
          result.message ||
            'Thank you for your quote request! We will get back to you within 24 hours.'
        );
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          contactNo: '',
          websiteURL: '',
          companyName: '',
          description: ''
        });
      } else {
        setSubmitStatus('error');
        setStatusMessage(
          result.message ||
            'Sorry, there was an error sending your request. Please try again.'
        );
      }
    } catch {
      setSubmitStatus('error');
      setStatusMessage(
        'Sorry, there was an error sending your request. Please try again.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="pricing-container">
      <div className="pricing-content">
        <motion.div
          className="pricing-form-wrapper"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="pricing-form-title">Get a Free Quote</h1>
          
          <form className="pricing-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name*"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name*"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email*"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="contactNo"
                  placeholder="Contact No*"
                  value={formData.contactNo}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <input
                  type="url"
                  name="websiteURL"
                  placeholder="Website URL*"
                  value={formData.websiteURL}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="companyName"
                  placeholder="Company Name*"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group full-width">
              <textarea
                name="description"
                placeholder="Description*"
                value={formData.description}
                onChange={handleChange}
                required
                rows="4"
              ></textarea>
            </div>

            <button
              type="submit"
              className="pricing-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
            
            {submitStatus === 'success' && (
              <div className="success-message">{statusMessage}</div>
            )}

            {submitStatus === 'error' && (
              <div className="error-message">{statusMessage}</div>
            )}
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Pricing;
